import './index.scss';

import { useTranslation } from 'react-i18next';
import { HeroModal } from '@/components/HeroModal';
import { Icon } from '@/components/Icon';

type SupportChannel = {
  key: string;
  /** Translation key of the channel name; the address itself is shown when there is none. */
  labelKey?: string;
  label?: string;
  href: string;
  kind: 'whatsapp' | 'mail';
};

// The departments' WhatsApp groups and the support e-mail (Keyvod "Sorun Bildir" dialog).
const SUPPORT_CHANNELS: SupportChannel[] = [
  {
    key: 'youtube',
    labelKey: 'sidebar-menu:sidebar-menu.supportModal.youtubeDepartment',
    href: 'https://chat.whatsapp.com/LxVZyWawF3a1wv0reLb3Ju?mode=gi_t',
    kind: 'whatsapp',
  },
  {
    key: 'facebook',
    labelKey: 'sidebar-menu:sidebar-menu.supportModal.facebookDepartment',
    href: 'https://chat.whatsapp.com/IwIdKGPRLnsD5MfRNOgOcV?mode=gi_t',
    kind: 'whatsapp',
  },
  {
    key: 'mail',
    label: 'ugur@merzigo.com',
    href: 'mailto:ugur@merzigo.com',
    kind: 'mail',
  },
];

type SupportModalProps = {
  open: boolean;
  onClose: () => void;
};

/** "Sorun Bildir": the contact channels the issue can be raised on. */
export const SupportModal = ({ open, onClose }: SupportModalProps) => {
  const { t } = useTranslation(['sidebar-menu']);

  return (
    <HeroModal
      open={open}
      badge={t('sidebar-menu:sidebar-menu.supportModal.badge')}
      title={t('sidebar-menu:sidebar-menu.reportIssue')}
      description={t('sidebar-menu:sidebar-menu.supportModal.intro')}
      onClose={onClose}
    >
      <div className="c-support">
        <span className="c-support__label">
          {t('sidebar-menu:sidebar-menu.supportModal.channels')}
        </span>
        {SUPPORT_CHANNELS.map((channel) => (
          <a
            key={channel.key}
            href={channel.href}
            target="_blank"
            rel="noopener noreferrer"
            className="c-support__channel"
          >
            <span
              className={`c-support__badge c-support__badge--${channel.kind}`}
              aria-hidden="true"
            >
              {channel.kind === 'mail' ? (
                <Icon name="mail" size={20} />
              ) : (
                <Icon name="chat" size={22} strokeWidth={1.8} />
              )}
            </span>
            <span className="c-support__name">
              {channel.labelKey ? t(channel.labelKey) : channel.label}
            </span>
            <Icon name="chevronRight" size={18} className="c-support__arrow" />
          </a>
        ))}
      </div>
    </HeroModal>
  );
};
